export default __webpack_public_path__ + "static/media/newlogo.15da545a.png";